import * as Cookie from './cookie';

const classSuscripto = '--suscripto';
const classNoSuscripto = '--nosuscripto';
const classLogueado = '--logueado';


export const VerificarUsuario = () => {
    if (Cookie.LeerCookie('cookieLogin')) {
        MostrarUsuario();
    } else {
        OcultarUsuario();
    }
}

export const Salir = () => {
    /*   const navHeader = document.getElementById('navHeader');
       if (navHeader) {
           navHeader.classList.remove(classLogueado);
           navHeader.classList.remove(classSuscripto);
           navHeader.classList.remove(classNoSuscripto);
       }
       */
    return OcultarUsuario();
}

function MostrarUsuario() {
    var nick = Cookie.LeerCookie('usuario%5Fdetalle%5Fnick');
    var usuarioemail = Cookie.LeerCookie('usuarioemail');

    const btnUsuario = document.getElementById('spanUsuario');
    if (btnUsuario) {
        // btnUsuario.innerHTML = nick + ' ' + btnUsuario.textContent;
        btnUsuario.innerHTML = usuarioemail;
        btnUsuario.addEventListener('click', function (event) { mostrarOcultarDesplegable(event) });

        window.onclick = function (event) {
            const desplegableUsuario = document.getElementById('user-menu');
            if (desplegableUsuario) {
                const classControlDesplegado = '.onoff-userDropdown';
                if (!event.target.matches(classControlDesplegado)) {
                    ocultarDesplegable();
                }
            }
        }
    }

    const ingresar = document.getElementById('btningresar');
    if (ingresar) {
        //ingresar.style.display = 'none';
        ingresar.classList.add('hlp-none');
        ingresar.classList.remove('hlp-block');
    }

    const valueSuscrib = document.getElementById('valueSuscrib');
    const suscriptor = document.getElementById('btnsuscribite');

    if (valueSuscrib) {
        if (Cookie.LeerCookie('ProductoPremiumId')) {
            //   valueSuscrib.classList.add(classSuscripto);
            //   valueSuscrib.classList.add(classLogueado);
            valueSuscrib.innerHTML = "Suscripción digital";
            if (suscriptor) {
                //suscriptor.style.display = 'none';
                suscriptor.classList.add('hlp-none');
                suscriptor.classList.remove('hlp-block');
            }

        } else {
            // valueSuscrib.classList.add(classLogueado);
            // valueSuscrib.classList.add(classNoSuscripto);
            valueSuscrib.innerHTML = "Sin Suscripción digital";
        }
    }


    const desplegableUsuario = document.getElementById('user-menu');
    if (desplegableUsuario) {
        desplegableUsuario.classList.remove('hlp-hide');
    }

}

function OcultarUsuario() {
    const usermenu = document.getElementById('menuUser');
    if (usermenu) {
        //usermenu.style.display = 'none';
        usermenu.classList.add('hlp-none');
    };

    const ingresar = document.getElementById('btningresar');
    if (ingresar) {
        //ingresar.style.display = 'initial';
        ingresar.classList.add('hlp-block');
        ingresar.classList.remove('hlp-none');
    }

    const suscriptor = document.getElementById('btnsuscribite');
    if (suscriptor) {
        //suscriptor.style.display = 'initial';

        suscriptor.classList.add('hlp-block');
        suscriptor.classList.remove('hlp-none');
    }

    const usuario = document.getElementById('spanUsuario');
    if (usuario) {
        //usuario.style.display = 'none';
        usuario.textContent = '&#9660;';
    }


    const desplegableUsuario = document.getElementById('user-menu');
    if (desplegableUsuario) {
        desplegableUsuario.classList.remove('hlp-hide');
    }

    localStorage.removeItem("token");

    //window.top.frames['iLogout'].location.href = window.config.Statics.SitioSeguroRegistracion + '/logout/logout.html?pagina=' + window.location.origin + window.config.Statics.LogoutUrl;

    //if (typeof fyre != "undefined") {
    //    fyre.conv.logout();
    //}

    return false;
}


const mostrarOcultarDesplegable = (event) => {
    //  const classDesplegado = '--desplegado';
    event.stopPropagation();
    const classDesplegado = '--active';
    const classControlDesplegado = 'onoff-userDropdown';
    const desplegableUsuario = document.getElementById('user-menu');
    if (desplegableUsuario) {
        if (desplegableUsuario.classList.contains(classDesplegado)) {
            desplegableUsuario.classList.remove(classDesplegado);
            document.getElementById('menuUser').classList.remove(classControlDesplegado);
        } else {
            desplegableUsuario.classList.add(classDesplegado);
            document.getElementById('menuUser').classList.add(classControlDesplegado);
        }
    }
}

const ocultarDesplegable = () => {
    const classDesplegado = '--active';
    const classControlDesplegado = 'onoff-userDropdown';
    const desplegableUsuario = document.getElementById('user-menu');
    if (desplegableUsuario) {
        desplegableUsuario.classList.remove(classDesplegado);
        document.getElementById('menuUser').classList.remove(classControlDesplegado);
    }
}

const btnSalir = document.getElementById('btnSalir');
if (btnSalir)
    btnSalir.addEventListener('click', Salir);


// WEBPACK FOOTER //
// ./Statics/scripts/common/usuario.js